import axios from "axios";
import { getAuth } from "firebase/auth";

const getApiBaseUrl = () =>
  process.env.REACT_APP_API_URL || "http://localhost:3000";

const getFirebaseIdToken = async () => {
  const currentUser = getAuth().currentUser;
  if (!currentUser) {
    throw new Error("Vui lòng đăng nhập lại trước khi kết nối Zalo");
  }
  return currentUser.getIdToken();
};

export const startZaloOAuth = async ({ userId, returnUrl }) => {
  const token = await getFirebaseIdToken();
  const response = await axios.get(`${getApiBaseUrl()}/api/zalo/oauth/start`, {
    params: {
      userId,
      returnUrl,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const fetchZaloAccounts = async (userId) => {
  const token = await getFirebaseIdToken();
  const response = await axios.get(`${getApiBaseUrl()}/api/zalo/accounts`, {
    params: { userId },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data?.accounts || [];
};

export const disconnectZaloAccount = async ({ userId, accountId }) => {
  const token = await getFirebaseIdToken();
  const response = await axios.post(
    `${getApiBaseUrl()}/api/zalo/disconnect`,
    { userId, accountId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const publishZaloPost = async ({
  userId,
  account,
  content,
  images = [],
  videos = [],
  generatorKey,
  options = {},
}) => {
  const token = await getFirebaseIdToken();
  const response = await axios.post(
    `${getApiBaseUrl()}/api/zalo/publish`,
    {
      userId,
      account,
      accountId: account?.accountId || account?.id,
      content,
      images,
      videos,
      generatorKey,
      options,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const fetchZaloQuota = async ({ userId, accountId, sync = false }) => {
  const token = await getFirebaseIdToken();
  const response = await axios.get(
    `${getApiBaseUrl()}/api/zalo/quota/${accountId}`,
    {
      params: { sync: sync ? "true" : undefined },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data?.quota || null;
};

export const updateZaloPackageConfig = async ({
  userId,
  accountId,
  packageType,
}) => {
  const token = await getFirebaseIdToken();
  const response = await axios.post(
    `${getApiBaseUrl()}/api/zalo/quota/${accountId}/config`,
    { packageType },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
